module.exports = __webpack_public_path__ + "static/CircularStd-BoldItalic-8f682a90d0d1ded2f43b1364af783fc8.woff";